<template>
    <vs-popup
            class="partial-modal"
            title="Restaurant compenseren"
            :active.sync="showPopup"
            v-if="activeOrder !== null"
    >

        <vs-list>
            <vs-list-item v-for="detail in activeOrder.details" :key="detail.id">
                <template slot="title">
                    <p>
                        <vs-checkbox v-model="selected" :vs-value="detail">{{ detail.product.name}}
                        </vs-checkbox>
                    </p>
                    <vs-input-number :min="detail.amount" :max="detail.quantity" v-model="detail.quantity"/>

                </template>
                <template slot="subtitle">
                    <ul class="pl-4">
                        <li v-for="addon in detail.addons" :key="addon.id" v-if="addon.price > 0">
                            <vs-checkbox v-model="selectedAddons" :vs-value="addon">{{ addon.name }} {{ addon.price}}
                            </vs-checkbox>
                        </li>
                    </ul>
                </template>
                € {{ (detail.quantity * detail.product.price).toFixed(2)}}
            </vs-list-item>
            <vs-list-item>
                <template slot="title">

                    <p>
                        <vs-checkbox v-if="activeOrder.delivery_fee > 0" v-model="refundDeliveryCost"
                                     :vs-value="activeOrder.delivery_fee">Bezorgkosten
                        </vs-checkbox>
                    </p>
                </template>
                {{ activeOrder.delivery_fee}}
            </vs-list-item>
            <vs-list-item>
                <template slot="title">
                    Totaal
                </template>
                {{ activeOrder.price}}
            </vs-list-item>
        </vs-list>
        <vs-button class="mr-3 w-full mb-2 vs-con-loading__container" id="refund-button" ref="loadableButton" v-if="allowRefund"
                   @click="partiallyRefundOrder">{{ refund }}
        </vs-button>        <vs-button class="mr-3 w-full mb-2" v-if="!allowRefund" disabled>{{ refund }}</vs-button>
    </vs-popup>
</template>

<script>
    export default {
        data() {
            return {
                massActive: false,
                showPopup: false,
                activeOrder: null,
                selected: [],
                voucher: false,
                selectedAddons: [],
                refundDeliveryCost: false
            };
        },
        computed: {
            refund() {
                let total = 0.00;
                this.selected.map(item => {
                    total += item.quantity * item.product.price;
                });
                this.selectedAddons.map(addon => {
                    total += parseFloat(addon.price);
                });
                if (this.refundDeliveryCost) {
                    total += this.activeOrder.delivery_fee;
                }
                if (!total >= 0.01) {
                    return "Je hebt nog niks geselecteerd";
                }
                return 'Stort € ' + this.totalRefund + ' terug naar het restaurant (ext btw)';
            },
            totalRefund() {
                let total = 0.00;
                this.selected.map(item => {
                    total += parseInt(item.quantity) * item.price;
                });
                this.selectedAddons.map(addon => {
                    total += parseFloat(addon.price);
                });

                if (this.refundDeliveryCost) {
                    total += parseFloat(this.activeOrder.delivery_fee);
                }
                return (total / 121 * 100).toFixed(2);
            },
            allowRefund() {
                let total = 0.00;
                this.selected.map(item => {
                    console.log(item.quantity);
                    total += parseInt(item.quantity) * item.price;
                });
                this.selectedAddons.map(addon => {
                    total += parseFloat(addon.price);
                });

                if (this.refundDeliveryCost) {
                    total += parseFloat(this.activeOrder.delivery_fee);
                }

                return total >= 0.01;
            }
        },
        watch: {
            showPopup() {
                this.selected = [];
                this.selectedAddons = [];
            }
        },
        methods: {
            partiallyRefundOrder() {
                if (!this.voucher) {
                    this.$vs.loading({
                        background: 'primary',
                        color: '#fff',
                        container: "#refund-button",
                        scale: 0.45
                    });
                    let data = {
                        _method: 'POST',
                        order_id: this.activeOrder.id,
                        price: this.totalRefund
                    };
                    this.$http
                        .post("v1/payment/refund/restaurant", data, {
                            headers: {
                                Authorization:
                                    "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
                            },
                        })
                        .then(() => {
                            this.showPopup = false;
                            this.$vs.loading.close("#refund-button > .con-vs-loading")
                            this.$util.notify('Terugstorting gelukt', 'Je hebt € ' + this.totalRefund + ' teruggestort naar de klant', this.$vs);
                        })
                        .catch((error) => {
                            this.$util.logError(error, this.$vs);
                            this.$vs.loading.close("#refund-button > .con-vs-loading")
                        });
                } else {
                    this.$util.notify('Voucher aangemaakt', 'Je hebt € ' + this.totalRefund + ' voucher naar de klant gestuurd', this.$vs);
                }
            },
        },
        mounted() {
            this.isMounted = true;
            this.$events.listen("open-compensate-modal", (order) => {
                this.activeOrder = order;
                this.showPopup = true;
            });
        },
    };
</script>

<style>
    .boxStyles {
        margin-right: 0.5em;
    }

    .con-vs-checkbox {
        padding-top: 7px;
    }
    .vs-input-number-size-null {
        width: 60px;
        margin-left: 50px;
    }
</style>>